import { Component, inject } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';

export interface ServiceRequestSummaryDialogData {
  serviceName: string;
  serviceDescription: string;
  addressLine: string;
  scheduleDate?: string;
  schedulePreferenceLabel: string;
  comment?: string;
}

@Component({
    selector: 'app-service-request-summary-dialog',
    templateUrl: './service-request-summary-dialog.component.html',
    styleUrls: ['./service-request-summary-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatDialogActions]
})
export class ServiceRequestSummaryDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<ServiceRequestSummaryDialogComponent>>(MatDialogRef);
  data = inject<ServiceRequestSummaryDialogData>(MAT_DIALOG_DATA);
  private readonly datePipe = inject(DatePipe);

  commentControl: FormControl<string | null>;

  constructor() {
    this.commentControl = new FormControl(this.data.comment ?? '', [
      Validators.maxLength(500),
    ]);
  }

  get formattedDate(): string {
    if (!this.data.scheduleDate) {
      return 'No especificada';
    }

    const parsed = new Date(this.data.scheduleDate);
    return (
      this.datePipe.transform(parsed, 'dd/MM/yyyy') ??
      this.data.scheduleDate.toString()
    );
  }

  onSubmit(): void {
    if (this.commentControl.invalid) {
      return;
    }

    this.dialogRef.close({
      confirmed: true,
      comment: this.commentControl.value ?? '',
    });
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }
}

